import { ChevronFirst, ChevronLast, MoreVertical } from "lucide-react"
import profile from "../assets/logo.png"
import { createContext, useContext, useState } from "react"
import { Link } from "react-router-dom"

const SidebarContext = createContext();

export default function Sidebar({ children, profileName = "constGenius", profileEmail = "constgenius@gmail.com", profileImage = null }) {
    const [expanded, setExpanded] = useState(true)
    return (
        <>
            <aside className="h-screen fixed md:sticky top-0 z-50">
                <nav className="h-full flex flex-col bg-white border-r shadow-sm relative z-50">
                    <div className="p-4 pb-2 flex justify-between items-center">
                        <div className={`overflow-hidden transition-all ${expanded ? "w-32" : "w-0"}`}>
                            {/* Placeholder for logo if needed, or text */}
                            <span className="text-xl font-bold text-indigo-600">AI Genius</span>
                        </div>
                        <button onClick={() => setExpanded((curr) => !curr)} className="p-1.5 rounded-lg bg-gray-50 hover:bg-gray-100">
                            {expanded ? <ChevronFirst /> : <ChevronLast />}
                        </button>
                    </div>

                    <SidebarContext.Provider value={{ expanded }}>

                        <ul className="flex-1 px-3">{children}</ul>
                    </SidebarContext.Provider>

                    <div className="border-t flex p-3">
                        <img src={profileImage || profile} alt="Profile" className="w-10 h-10 rounded-md" />
                        <div className={`flex justify-between items-center overflow-hidden transition-all ${expanded ? "w-52 ml-3" : "w-0"} `}>
                            <div className="leading-4">
                                <h4 className="font-semibold">{profileName}</h4>
                                <span className="text-xs text-gray-600">{profileEmail}</span>
                            </div>
                            <MoreVertical size={20} />
                        </div>
                    </div>
                </nav>

                {/* Mobile Backdrop */}
                {expanded && (
                    <div
                        className="fixed inset-0 bg-black/30 backdrop-blur-sm z-40 md:hidden"
                        onClick={() => setExpanded(false)}
                    />
                )}
            </aside>
        </>
    )
}

export function SidebarItem({ icon, text, active, alert, to, onClick }) {
    const { expanded } = useContext(SidebarContext)

    // If 'to' is provided, wrap in Link, otherwise just a list item
    const content = (
        <li
            onClick={onClick}
            className={`relative flex items-center py-2 px-3 my-1 font-medium rounded-md cursor-pointer transition-colors group ${active ? "bg-gradient-to-tr from-indigo-200 to-indigo-100 text-indigo-800" : "hover:bg-indigo-50 text-gray-600"}`}
        >
            {icon}
            <span className={`overflow-hidden transition-all ${expanded ? "w-52 ml-3" : "w-0"}`}>{text}</span>
            {alert && (
                <div className={`absolute right-2 w-2 h-2 rounded bg-indigo-400 ${expanded ? "" : "top-2"}`}>

                </div>
            )}

            {!expanded && (
                <div className={`absolute left-full rounded-md px-2 py-1 ml-6 bg-indigo-100 text-indigo-800 text-sm invisible opacity-20 -translate-x-3 transition-all group-hover:visible group-hover:opacity-100 group-hover:translate-x-0 z-50 whitespace-nowrap`}>
                    {text}
                </div>
            )}
        </li>
    );

    if (to) {
        return <Link to={to}>{content}</Link>
    }

    return content;
}
